import { breakpoints, capitalizeFirstLetterAndLowerCaseRest } from '@msc-b2c/shared-utils';

export class Gallery {
  private readonly gallery: HTMLElement;

  constructor(gallery: HTMLElement) {
    this.gallery = gallery;
  }

  init() {
    const seeAllContentButtons = this.gallery.querySelectorAll('.see-all-content-button');
    const seeLessContentButtons = this.gallery.querySelectorAll('.see-less-content-button');
    const numberOfTabsWithButton = seeAllContentButtons.length;
    const isMobile = window.innerWidth <= breakpoints.md;
    for (let tab = 0; tab < numberOfTabsWithButton; tab++) {
      const seeAllContentButton = seeAllContentButtons[tab];
      const seeLessContentButton = seeLessContentButtons[tab];
      try {
        if (seeAllContentButton && seeLessContentButton) {
          seeAllContentButton.addEventListener('click', () => {
            const cmpContainer = seeAllContentButton.closest('.cmp-container');
            const galleryTeasers = cmpContainer?.querySelectorAll('.gallery-teaser');
            // Expand functionality: show all teasers
            galleryTeasers?.forEach((teaser) => {
              teaser.classList.remove('hide');
            });
            seeAllContentButton.classList.add('hide');
            seeLessContentButton.classList.remove('hide');
            let firstTeaser = galleryTeasers?.[0];
            if (isMobile) {
              firstTeaser = galleryTeasers?.[5];
            }
            firstTeaser?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
          seeLessContentButton.addEventListener('click', () => {
            const cmpContainer = seeLessContentButton.closest('.cmp-container');
            const galleryTeasers = cmpContainer?.querySelectorAll('.gallery-teaser');
            galleryTeasers?.forEach((teaser, index) => {
              if (index >= 6) {
                teaser.classList.add('hide');
              }
            });
            seeAllContentButton.classList.remove('hide');
            seeLessContentButton.classList.add('hide');
            let firstTeaser = galleryTeasers?.[0];
            if (isMobile) {
              firstTeaser = galleryTeasers?.[5];
            }
            firstTeaser?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
        this.gallery.querySelectorAll('.cmp-teaser__title').forEach((element) => {
          let words = element.textContent?.trim()?.split(' ');
          words = words?.map((w) => {
            if (w !== 'MSC') {
              return capitalizeFirstLetterAndLowerCaseRest(w);
            } else {
              return w;
            }
          });
          element.textContent = words?.join(' ') ?? '';
        });
      } catch (error) {
        console.error('Error in Gallery init', error);
      }
    }
  }
}

function onDocumentReady(): void {
  document.querySelectorAll('.gallery-contentfragment').forEach((node) => {
    const gallery = new Gallery(node as HTMLElement);
    gallery.init();
  });
}

if (document.readyState !== 'loading') {
  onDocumentReady();
} else {
  document.addEventListener('DOMContentLoaded', onDocumentReady);
}
